import React, { FC, useState, useEffect } from 'react';
import Lottie from 'react-lottie-player';
import LodingBar from 'src/assets/bodymovin/logo_loading.json';
import './style.scss';

interface Props {
  styleDef?: any;
}

interface lottieProps {
  loop: boolean;
  speed: number;
  play: boolean;
  direction: 1 | -1;
  segments: [number, number];
}

const InputConfirmBox: FC<Props> = ({ styleDef }) => {
  const [lottieState, setLottieState] = useState<lottieProps>({
    loop: true,
    speed: 1.5,
    play: true,
    direction: 1,
    segments: [0, 0],
  });
  const styleSet =
    styleDef !== undefined ? styleDef : { width: '100%', height: '100%', alignSelf: 'center' };

  // lottie
  return (
    <>
      <div className="_bodymovin_loading_box">
        <div className="_logo">
          <Lottie
            loop={lottieState.loop}
            speed={lottieState.speed}
            play={lottieState.play}
            animationData={LodingBar}
            direction={lottieState.direction}
            segments={lottieState.segments}
            style={styleSet}
          />
        </div>
      </div>
    </>
  );
};

export default InputConfirmBox;
